import './App.css';
import './responsive.css';
import Home from './pages/Home';
import { BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import { HelmetProvider } from "react-helmet-async";
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import SellerDetail from './pages/SellerDetail';

function App() {

  const checkIfUserIsLoggedIn = () => {
    return localStorage.getItem('user') !== null;

  }
  const isLoggedIn = checkIfUserIsLoggedIn();


  return (
    <div className="App">
       <HelmetProvider>
      <Router>
        <Routes>
       
          <Route index element={< Home/>} />
          <Route path='/home' element={< Home/>} />
          <Route path='/store' element={<Shop />} />
          <Route path='/terms-and-condition' element={<Terms />} />
          <Route path='/privacy-policy' element={<Privacy />} />
          <Route path='/contact' element={<Contact />} />       
          <Route path='/shop' element={< Shop/>} />
            {/* Category page */}
        <Route path="/category/:id" element={<Shop />} />
        <Route path="/product/:id" element={<ProductDetail />} />

        <Route
    path="/seller/:sellerId"
    element={<SellerDetail />}
/>




        </Routes>
      </Router>

</HelmetProvider>

    </div>
  );
}

export default App;
